import removeEmptyFields from '../utils/removeEmptyFields';

/**
  * @function getName
  * @param {Object} values
  * @param {string} values.prefix - The prefix of the name
  * @param {string} values.title - The title of the name
  * @param {string} values.middleName - The middle name of the name
  * @param {string} values.firstName - The first name of the name
  * @param {string} values.lastName - The last name of the name
  * @returns {{
  *  type: 'PRIMARY',
  *  language: 'DE',
  *  prefix: string,
  *  title: string,
  *  middleName: string,
  *  firstName: string,
  *  lastName: string,
  * }}
*/
function getName({
  prefix,
  title,
  middleName,
  firstName,
  lastName,
}) {
  return removeEmptyFields({
    type: 'PRIMARY',
    language: 'DE',
    prefix,
    title,
    middleName,
    firstName,
    lastName,
  });
}

export default getName;
